import { render, staticRenderFns } from "./ToolsDashboard.vue?vue&type=template&id=64e3f8e6"
import script from "./ToolsDashboard.vue?vue&type=script&lang=js"
export * from "./ToolsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports